import React, { useContext, useState, useEffect } from "react";
import TilesMatrix from "../components/TilesMatrix";
import EditLessonModal from "../components/EditLessonModal";
import { apiLessonDataContext } from '../context/AppContext';
import { getCurrentUser } from 'aws-amplify/auth';

function Lessons() {
    const [apiLessonData] = useContext(apiLessonDataContext);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedLesson, setSelectedLesson] = useState(null);
    const [isNewLesson, setIsNewLesson] = useState(false);
    const [user, setUser] = useState(null);

    useEffect(() => {
        getCurrentUser()
            .then(user => setUser(user))
            .catch(() => setUser(null)); // not signed in
    }, []);

    const handleEditClick = (lesson) => {
        setSelectedLesson(lesson);
        setIsNewLesson(false);
        setIsModalOpen(true);
    };

    const handleAddNew = () => {
        setSelectedLesson(null);
        setIsNewLesson(true);
        setIsModalOpen(true);
    };

    const handleModalClose = (wasSuccessful) => {
        setIsModalOpen(false);
        setSelectedLesson(null);
        setIsNewLesson(false);
    };

    return (
        <div data-testid="lessons-page">
            {user && (
                <div className="container mt-4">
                    <button 
                        className="btn btn-primary mb-4"
                        onClick={handleAddNew}
                    >
                        Add New Lesson
                    </button>
                </div>
            )}
            <TilesMatrix 
                data={apiLessonData} 
                base_path="lessen" 
                page_title="Onze lessen" 
                onEditClick={user ? handleEditClick : undefined}
            />
            {isModalOpen && (
                <EditLessonModal
                    isOpen={isModalOpen}
                    onClose={handleModalClose}
                    link={selectedLesson?.link}
                    name={selectedLesson?.name}
                    isNew={isNewLesson}
                />
            )}
        </div>
    );
}

export default Lessons;